import { IInitiateDepositResponse, IWithdrawalResponse } from "@finbackoffice/clientbff-client";
import {
    Dispatch,
    FC,
    PropsWithChildren,
    SetStateAction,
    createContext,
    useMemo,
    useState,
} from "react";

export type DepositStepType = "first" | "second" | "complete";
export type WithdrawalStepType = "first" | "complete";

export interface IDepositData extends IInitiateDepositResponse {
    base64QrCode?: string;
}

interface IPixWalletDataContext {
    setDepositStep: (step: DepositStepType) => void;
    depositStep: DepositStepType;
    depositData: IDepositData | null;
    setDepositData: Dispatch<SetStateAction<IDepositData | null>>;
    setWithdrawalStep: (step: WithdrawalStepType) => void;
    withdrawalStep: WithdrawalStepType;
    withdrawalData: IWithdrawalResponse | null;
    setWithdrawalData: Dispatch<SetStateAction<IWithdrawalResponse | null>>;
}

export const PixWalletDataContext = createContext<IPixWalletDataContext>(null as any);

export const PixWalletDataProvider: FC<PropsWithChildren> = ({ children }) => {
    const [depositStep, setDepositStep] = useState<DepositStepType>("first");
    const [depositData, setDepositData] = useState<IDepositData | null>(null);
    const [withdrawalStep, setWithdrawalStep] = useState<WithdrawalStepType>("first");
    const [withdrawalData, setWithdrawalData] = useState<IWithdrawalResponse | null>(null);

    const value = useMemo(
        () => ({
            setDepositStep,
            depositStep,
            depositData,
            setDepositData,
            withdrawalStep,
            setWithdrawalStep,
            withdrawalData,
            setWithdrawalData,
        }),
        [
            setDepositStep,
            depositStep,
            depositData,
            setDepositData,
            withdrawalStep,
            setWithdrawalStep,
            withdrawalData,
            setWithdrawalData,
        ],
    );

    return <PixWalletDataContext.Provider value={value}>{children}</PixWalletDataContext.Provider>;
};
